module.exports = new __parcel__URL__("mining_launch_button.e64956f4.png").toString();